import React from 'react';

class Start extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
  
    render() {
        return(
            <div className="StartButton">
                <button onClick={this.props.gameStart} class="bg-white hover:bg-gray-100 text-2xl text-gray-800 font-semibold py-6 px-12 border border-gray-300 rounded shadow">
                    Start 🏁
                </button>
            </div>
        );

    }
  }
export default Start;